import {gsap} from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin( ScrollToPlugin);

export default ( object = {} ) => ( {
    showSuccess: false,

    onClickDownloadGame( event ) {
        event.preventDefault();
        let trigger = event.target.closest( '.button' ),
            self = this,
            _href = trigger.href;

        window.location.href = _href;
        self.showSuccess = true;

        // Use setTimeout to ensure the code runs before navigation
        setTimeout(function() {
            gsap.to( window, {
                duration: 0.6,
                scrollTo: {
                    y: "#download-success-message",
                    offsetY: 100
                }
            });

        }, 500); // Adjust the delay as needed
    },

    init() {}
} );
